import axios from 'axios';
axios.defaults.withCredentials = true;

const EventsStore = {
  state: {
    omcMabulCoin: 0,
    omcMabulUsrStatus: {
      attendance: 0,
      application: 0,
      invitation: 0,
      dice: 0,
      coin: 0,
      omc: 0,
    },
  },
  mutations: {
    setOmcMabulCoin(state, omcMabulCoin) {
      state.omcMabulCoin = omcMabulCoin;
    },
    setOmcMabulUsrStatus(state, { attendance, application, invitation, dice, coin, omc }) {
      state.omcMabulUsrStatus.attendance = attendance;
      state.omcMabulUsrStatus.application = application;
      state.omcMabulUsrStatus.invitation = invitation;
      state.omcMabulUsrStatus.dice = dice;
      state.omcMabulUsrStatus.coin = coin;
      state.omcMabulUsrStatus.omc = omc;
    },
  },
  actions: {
    async getOmcMabulCoin({ commit }) {
      try {
        const { data: omcMabulCoin } = await axios.get(`${process.env.VUE_APP_TEST_SERVER}/mabul/mission2/coin`);
        commit('setOmcMabulCoin', omcMabulCoin);

        return;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getOmcMabulUsrStatus({ commit }) {
      try {
        const { data: omcMabulUsrStatus } = await axios.get(`${process.env.VUE_APP_TEST_SERVER}/mabul/mission1`);
        commit('setOmcMabulUsrStatus', omcMabulUsrStatus);

        return;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
};

export default EventsStore;
